export function navigationDropdown() {
  document.addEventListener('DOMContentLoaded', function() {
    const megaMenu = document.getElementById('mega-menu');
    const megaMenuContent = document.getElementById('mega-menu-content');
    const navBar = document.getElementById('nav-bar');
    const navItems = document.querySelectorAll('.nav-item');
    const termContents = document.querySelectorAll('.term-content');
    const arrow = document.getElementById('mega-menu-arrow');

    let hideTimeout;

    function setMenuTop() {
      // The mega-menu is position:fixed (viewport-relative), and the header
      // is now sticky, so use the nav's viewport position WITHOUT scrollY.
      const bottom = navBar.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--menu-top', bottom + 'px');
    }

    setMenuTop();
    window.addEventListener('resize', setMenuTop);
    window.addEventListener('scroll', setMenuTop);

    function positionArrow(navItem) {
      const rect = navItem.getBoundingClientRect();
      arrow.style.left = (rect.left + rect.width / 2) + 'px';
      
      if (navItem.dataset.term === 'menu-only') {
        arrow.style.borderBottomColor = 'var(--color-ab-sand)';
      } else {
        arrow.style.borderBottomColor = 'var(--color-ab-palegreen)';
      }
    }

    function showMenu(termSlug, navItem) {
      clearTimeout(hideTimeout);

      // Recompute the offset on open so the dropdown always sits directly
      // under the nav at its CURRENT height (the sticky header condenses on
      // scroll, and the expand/condense transition can otherwise leave the
      // last scroll-computed value stale).
      setMenuTop();

      termContents.forEach(content => content.classList.add('hidden'));

      if (termSlug && termSlug !== 'menu-only') {
        const activeContent = megaMenuContent.querySelector('[data-term="' + termSlug + '"]');
        if (activeContent) activeContent.classList.remove('hidden');
      }

      positionArrow(navItem);
      megaMenu.classList.add('is-active');
    }

    function hideMenu() {
      hideTimeout = setTimeout(function() {
        megaMenu.classList.remove('is-active');
      }, 100);
    }

    navItems.forEach(function(item) {
      const hasChildren = item.dataset.hasChildren === 'true';
      const termSlug = item.dataset.term;

      if (hasChildren || termSlug === 'menu-only') {
        item.addEventListener('mouseenter', function() {
          showMenu(termSlug, item);
        });
        item.addEventListener('mouseleave', hideMenu);
      }
    });

    megaMenu.addEventListener('mouseenter', () => clearTimeout(hideTimeout));
    megaMenu.addEventListener('mouseleave', hideMenu);

    // When the sticky header finishes condensing/expanding, its height has
    // changed — refresh the dropdown offset so an open menu stays aligned.
    const siteHeader = document.getElementById('site-header');
    if (siteHeader) {
      siteHeader.addEventListener('transitionend', setMenuTop);
    }
  });
}